import type { DailyItemLocaleRef } from './types';

export function buildDailyItemLocalesUrl({ artistId, dailySeriesId, dailyItemId }: DailyItemLocaleRef) {
  return `/web/studio/artists/${artistId}/daily-series/${dailySeriesId}/daily-items/${dailyItemId}/locales`;
}
